<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Yeni Ürün Çevirisi Ekle">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span><strong>Not:</strong> Eklenecek Ürün benzersiz olmalıdır...</span>
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            to="/products"
          >
            Ürün Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Ürün Çeviri Ekleme Formu">
            <b-row>
              <b-col md="12">
                <b-form-group label="Ürün Adı" label-for="name">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Ürün Adı"
                  >
                    <b-form-textarea
                      id="name"
                      v-model="name"
                      placeholder="Ürün Adı"
                      rows="6"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="name.length >= chars.name ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="name.length >= chars.name ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ name.length }}</span>
                      /
                      {{ chars.name }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Metin Rengi" label-for="textColor">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Ürün Adı"
                  >
                    <b-form-input
                      id="Metin Rengi"
                      v-model="textColor"
                      placeholder="Metin Rengi"
                      :state="errors.length > 0 ? false : null"
                      :class="textColor.length >= chars.textColor ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="textColor.length >= chars.textColor ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ textColor.length }}</span>
                      /
                      {{ chars.textColor }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Buton Rengi" label-for="buttonColor">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Buton Rengi"
                  >
                    <b-form-input
                      id="Buton Rengi"
                      v-model="buttonColor"
                      placeholder="Buton Rengi"
                      :state="errors.length > 0 ? false : null"
                      :class="buttonColor.length >= chars.buttonColor ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="buttonColor.length >= chars.buttonColor ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ buttonColor.length }}</span>
                      /
                      {{ chars.buttonColor }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Arkaplan Rengi" label-for="backgroundColor">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Arkaplan Rengi"
                  >
                    <b-form-input
                      id="backgroundColor"
                      v-model="backgroundColor"
                      placeholder="Arkaplan Rengi"
                      :state="errors.length > 0 ? false : null"
                      :class="backgroundColor.length >= chars.backgroundColor ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="backgroundColor.length >= chars.backgroundColor ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ backgroundColor.length }}</span>
                      /
                      {{ chars.backgroundColor }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-form-group label="Alkol Oranı" label-for="alcoholValue">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Alkol Oranı"
                  >
                    <b-form-input
                      id="alcoholValue"
                      v-model="alcoholValue"
                      placeholder="Alkol Oranı"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        alcoholValue.length >= chars.alcoholValue ? 'text-danger' : ''
                      "
                      type="number"
                      inputmode="decimal"
                      step="0.5"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        alcoholValue.length >= chars.alcoholValue ? 'bg-danger' : ''
                      "
                    >
                      <span class="char-count">{{ alcoholValue.length }}</span>
                      /
                      {{ chars.alcoholValue }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Alt Metin" label-for="subText">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Alt Metin"
                  >
                    <b-form-textarea
                      id="subText"
                      v-model="subText"
                      placeholder="Alt Metin"
                      rows="6"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="subText.length >= chars.subText ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="subText.length >= chars.subText ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ subText.length }}</span>
                      /
                      {{ chars.subText }}
                    </small>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Tadım Notları" label-for="alcoholTasteNotes">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Tadım Notları"
                  >
                    <b-form-textarea
                      id="alcoholTasteNotes"
                      v-model="alcoholTasteNotes"
                      placeholder="Tadım Notları"
                      rows="6"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        alcoholTasteNotes.length >= chars.alcoholTasteNotes
                          ? 'text-danger'
                          : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        alcoholTasteNotes.length >= chars.alcoholTasteNotes
                          ? 'bg-danger'
                          : ''
                      "
                    >
                      <span class="char-count">{{ alcoholTasteNotes.length }}</span>
                      /
                      {{ chars.alcoholTasteNotes }}
                    </small>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Yemek Uyumu" label-for="mealMatch">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Yemek Uyumu"
                  >
                    <b-form-textarea
                      id="mealMatch"
                      v-model="mealMatch"
                      placeholder="Yemek Uyumu"
                      rows="6"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="mealMatch.length >= chars.mealMatch ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="mealMatch.length >= chars.mealMatch ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ mealMatch.length }}</span>
                      /
                      {{ chars.mealMatch }}
                    </small>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <DragDropImage
                  v-if="productImage != null"
                  ref="refProductImage"
                  title="Ürün Görseli"
                  :imageUrl="productImage"
                  :required="false"
                ></DragDropImage>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <DragDropImage
                  v-if="productBgImage != null"
                  ref="refProductBgImage"
                  title="Ürün Arkaplan Görseli"
                  :imageUrl="productBgImage"
                  :required="false"
                ></DragDropImage>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <DragDropImage
                  v-if="productCircleImage != null"
                  ref="refProductCircleImage"
                  title="Ürün Daire Görseli"
                  :imageUrl="productCircleImage"
                  :required="false"
                ></DragDropImage>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="mt-5">
                <div>
                  <b-button
                    class="float-right mt-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    @click="postConfirmText(false)"
                  >
                    <b-spinner v-if="spinner === true && isDraft === false" small />
                    {{
                      spinner === true && isDraft === false ? "Yayınlanıyor" : "Yayınla"
                    }}
                  </b-button>
                </div>
                <div>
                  <b-button
                    class="float-right mt-2 mr-1"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-warning"
                    @click="postConfirmText(true)"
                  >
                    <b-spinner v-if="spinner == true && isDraft == true" small />
                    {{
                      spinner == true && isDraft == true
                        ? "Taslağa Kaydediliyor"
                        : "Taslağa Kaydet"
                    }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import Editor from "../components/Editor";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    Editor,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      id: this.$route.params.idParam,
      targetLocale: this.$route.query.targetLocale,
      name: "",
      subText: "",
      mealMatch: "",
      alcoholTasteNotes: "",
      textColor: "",
      buttonColor: "",
      backgroundColor: "",
      alcoholValue: 10,
      productImage: null,
      productBgImage: null,
      productCircleImage: null,
      isDraft: false,
      spinner: false,
      chars: {
        name: 1000,
        code: 2,
        subText: 2000,
        mealMatch: 2000,
        alcoholTasteNotes: 2000,
        alcoholValue: 2,
        textColor: 255,
        buttonColor: 255,
        backgroundColor: 1000,
      },
    };
  },
  watch: {},
  methods: {
    getProductById() {
      endpoints
        .getProductById(this.id, 'tr', () => {})
        .then((data) => {
          this.name = data.response.name;
          this.textColor = data.response.colors.textColor;
          this.buttonColor = data.response.colors.buttonColor;
          this.backgroundColor = data.response.colors.backgroundColor;
          this.isDraft = data.response.isDraft;
          this.alcoholValue = data.response.alcoholValue;

          this.subText = data.response.texts.subText;
          this.mealMatch = data.response.texts.mealMatch;
          this.alcoholTasteNotes = data.response.texts.alcoholTasteNotes;
          this.productImage = data.response.images.productImage;
          this.productBgImage = data.response.images.productBgImage;
          this.productCircleImage = data.response.images.productCircleImage;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postConfirmText(isDraft) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Yeni Ürün çevirisini kaydetmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let formData = new FormData();
          formData.append("id", this.id);
          formData.append("name", this.name);
          formData.append("subText", this.subText);
          formData.append("mealMatch", this.mealMatch);
          formData.append("alcoholTasteNotes", this.alcoholTasteNotes);
          formData.append("textColor", this.textColor);
          formData.append("buttonColor", this.buttonColor);
          formData.append("backgroundColor", this.backgroundColor);
          formData.append("alcoholValue", this.alcoholValue);
          formData.append("isDraft", this.isDraft ? 1 : 0);
          if (this.$refs.refProductImage.image != null) {
            formData.append("productImage", this.$refs.refProductImage.image);
          }
          if (this.$refs.refProductBgImage.image != null) {
            formData.append("productBgImage", this.$refs.refProductBgImage.image);
          }
          if (this.$refs.refProductCircleImage.image != null) {
            formData.append("productCircleImage", this.$refs.refProductCircleImage.image);
          }

          endpoints
            .postProductTranslation(formData, this.targetLocale, () => {})
            .then((data) => {
              this.spinner = false;
              if (data.status) {
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Yeni Ürün Çevirisi eklendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result) => {
                  if (result.value) {
                    this.$router.push({
                      path: `/products`,
                    });
                  }
                });
              } else {
                this.$swal({
                  title: "Hata!",
                  text: "Ürün benzersiz değil!",
                  icon: "error",
                  confirmButtonText: "Tamam",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then((result) => {
                  if (result.value) {
                  }
                });
              }
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
  },
  created() {},
  destroyed() {},
  mounted() {
    this.getProductById();
  },
  setup() {},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
